import { Theme, createStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1),
      },
    },
    paper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(4),
      textAlign: "center",
      position: "relative",
      minWidth: 400,
      maxWidth: 500,
      borderRadius: 16,
      outline: "none",
      [theme.breakpoints.down("sm")]: {
        minWidth: "90vw",
        maxWidth: "90vw",
        padding: theme.spacing(3),
        margin: theme.spacing(2),
      },
      [theme.breakpoints.down("xs")]: {
        minWidth: "95vw",
        maxWidth: "95vw",
        padding: theme.spacing(2),
        margin: theme.spacing(1),
      },
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    greeting: {
      fontSize: 20,
      fontWeight: 700,
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        fontSize: 18,
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
        marginBottom: theme.spacing(1),
      },
    },
    icon: {
      width: 238,
      height: 213,
      [theme.breakpoints.down("xs")]: {
        width: 180,
        height: 160,
      },
    },
    message: {
      fontSize: 16,
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(3),
      lineHeight: 1.5,
      width: 280,
      textAlign: "left",
      fontWeight: 700,
      [theme.breakpoints.down("sm")]: {
        fontSize: 14,
        width: "100%",
        textAlign: "center",
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: 13,
        marginBottom: theme.spacing(1.5),
      },
    },
    button: {
      borderRadius: 24,
      padding: theme.spacing(1.5, 4),
      textTransform: "none",
      fontSize: 16,
      fontWeight: 600,
      height: 32,
      width: 200,
      [theme.breakpoints.down("sm")]: {
        fontSize: 14,
        width: "100%",
        maxWidth: 250,
        padding: theme.spacing(1.5, 3),
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: 13,
        maxWidth: 200,
        padding: theme.spacing(1, 2),
      },
    },
  });
